import * as React from "react"
import { getAzureApiManagementClient } from "../../api/client"
import { PlansApi } from "../../api/services/plans"
import { WeightClassesApi } from "../../api/services/weight-classes"
import { ServicesApi } from "../../api/services/services"
import { TeamsApi } from "../../api/services/teams"
import { TransportsApi } from "../../api/services/transports"
type ApiProviderProps = { children: React.ReactNode }
export interface ApiContextInterface {
    planApi: PlansApi
    servicesApi: ServicesApi
    teamsApi: TeamsApi
    transportsApi: TransportsApi
    weightClassesApi: WeightClassesApi
}
const ApiContext = React.createContext<ApiContextInterface | null>(null)

const ApiProvider = ({ children }: ApiProviderProps) => {
    const azureApimClient = getAzureApiManagementClient()
    const planApi = new PlansApi(azureApimClient)
    const servicesApi = new ServicesApi(azureApimClient)
    const teamsApi = new TeamsApi(azureApimClient)
    const transportsApi = new TransportsApi(azureApimClient)
    const weightClassesApi = new WeightClassesApi(azureApimClient)
    const value = {
        planApi,
        servicesApi,
        teamsApi,
        transportsApi,
        weightClassesApi,
    }
    return <ApiContext.Provider value={value}> {children} </ApiContext.Provider>
}

export { ApiProvider, ApiContext }
